import React from "react";

function Basket() {
  return (
    <>
      <svg
        width="14"
        height="19"
        viewBox="0 0 14 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.16665 13.9516C4.48557 13.7276 2.94902 12.8417 1.8693 11.4739C0.789582 10.1061 0.247713 8.35906 0.35383 6.58791C0.459948 4.81676 1.20609 3.15437 2.4406 1.93864C3.67511 0.722902 5.30535 0.0450485 6.99998 0.0428486C8.69668 0.0415255 10.33 0.717724 11.5672 1.93366C12.8044 3.1496 13.5523 4.81377 13.6585 6.5871C13.7648 8.36042 13.2214 10.1094 12.139 11.4778C11.0567 12.8461 9.51686 13.7308 7.83331 13.9516V15.7615C11.1216 15.8418 13.6666 16.3925 13.6666 17.0601C13.6666 17.7826 10.6816 18.3691 6.99998 18.3691C3.31831 18.3691 0.333313 17.7826 0.333313 17.0601C0.333313 16.3925 2.87831 15.8418 6.16665 15.7615V13.9516ZM6.99998 12.2603C8.32606 12.2603 9.59783 11.7087 10.5355 10.7267C11.4732 9.74478 12 8.41297 12 7.02427C12 5.63558 11.4732 4.30377 10.5355 3.32181C9.59783 2.33986 8.32606 1.7882 6.99998 1.7882C5.6739 1.7882 4.40213 2.33986 3.46445 3.32181C2.52676 4.30377 1.99998 5.63558 1.99998 7.02427C1.99998 8.41297 2.52676 9.74478 3.46445 10.7267C4.40213 11.7087 5.6739 12.2603 6.99998 12.2603ZM6.99998 8.76963C6.55795 8.76963 6.13403 8.58574 5.82147 8.25843C5.50891 7.93111 5.33331 7.48717 5.33331 7.02427C5.33331 6.56138 5.50891 6.11744 5.82147 5.79012C6.13403 5.4628 6.55795 5.27892 6.99998 5.27892C7.44201 5.27892 7.86593 5.4628 8.17849 5.79012C8.49105 6.11744 8.66665 6.56138 8.66665 7.02427C8.66665 7.48717 8.49105 7.93111 8.17849 8.25843C7.86593 8.58574 7.44201 8.76963 6.99998 8.76963Z"
          fill="#E82223"
        />
      </svg>
    </>
  );
}

export default Basket;
